module.exports = __webpack_public_path__ + "img/main.cd38bf12.jpg";